/** Shared display cache populated by useEventCategories / stats responses. */

let colorByCode = {};
let labelByCode = {};

export function setCategoryDisplayCache(categories) {
  if (!Array.isArray(categories) || categories.length === 0) return;
  const nextColors = {};
  const nextLabels = {};
  categories.forEach((c) => {
    if (!c || !c.code) return;
    if (c.color) nextColors[c.code] = c.color;
    if (c.label) nextLabels[c.code] = c.label;
  });
  colorByCode = { ...colorByCode, ...nextColors };
  labelByCode = { ...labelByCode, ...nextLabels };
}

export function cachedColorForCategory(code, fallback) {
  return colorByCode[code] || fallback;
}

export function cachedLabelForCategory(code, fallback) {
  return labelByCode[code] || fallback;
}
